import { gql, useQuery } from "@apollo/client";

export const Client = gql`
	query getUser($id: String) {
		getUser(id: $id) {
			_id
			email
			name
			phoneNumber
			addressInfo {
				Address
				postalCode
			}
			localidade
			nif
			avatar
			createdAt
		}
	}
`;
